
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as formkitCZWOwRFP7SPAwn1QecgSgHzO6wJGh4dbrhXaEN3ipW4Meta } from "/builds/pro/webshop/frontend/src/img/app/pages/design-system/dependencies/formkit.vue?macro=true";
import { default as _91_46_46_46store_93brhCaXzhVnoKQDH2sJZ7_8uG3z8n47R4oKHF7b1GR28Meta } from "/builds/pro/webshop/frontend/src/img/app/pages/serviceaanvraag/[...store].vue?macro=true";
import { default as _126blog_45detailQsedNVA572IzS8VMybq4zdmMhT4ybFrc90tFG7pwSKUMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/~blog-detail.vue?macro=true";
import { default as _126brands3s1i3Cc6ufqTnv2iJusHZWz7yupDqTzyqzs0DyDi47wMeta } from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/pages/~brands.vue?macro=true";
import { default as _126cms_45columnsSWu9Ako3LAj3eqvXIaXBPOnYF9nm6lSzQbGb7DnTG6MMeta } from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-strapi/src/app/pages/~cms-columns.vue?macro=true";
import { default as _126customer_45service_45detaillDnXKr7ZExKcfGdzc5N3TckGQRgBssjbFr8vtxmY5rYMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/~customer-service-detail.vue?macro=true";
import { default as _126pdptBF_7Dt7mhPQhqRzRpLx41bV9wOASyUpzsHDmUm2onEMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/~pdp.vue?macro=true";
import { default as _126store_45detailHinI6R68JM8PXjGn84rygNb50Okk8jQb264j5gw5N8sMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/~store-detail.vue?macro=true";
import { default as cartJb2CqbsQ8wmFlPrC_YS0bat7RRDBC0J_mi_mBS1441sMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/cart.vue?macro=true";
import { default as paymentpstU9iFt9EG8YABmqpzqNXvRy0OECqzLi7UYofwO94QMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/checkout/payment.vue?macro=true";
import { default as shipmentE9X1OumRFD57_S0mtR7KAQ2WYPApNatBVmMqonrIh8QMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/checkout/shipment.vue?macro=true";
import { default as indexCHnLsUDw_3Z2vvqIYgbL1JAnx_OSyLdCpoCldOH3SUwMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/checkout/index.vue?macro=true";
import { default as checkouty60XFfaVhYQ2JvIZPbPt8Cjt39DmZX_k91zZExOBJLoMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/checkout.vue?macro=true";
import { default as embed9WtzouZDbYALE3l_kCWtyakAmZR66Nk3nYdIl2a4r5wMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/embed.vue?macro=true";
import { default as empty_45layout4KSMdh5RTw4o2VFP7GY1E_qv8XSPt4FagwQPgqURDeoMeta } from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/pages/empty-layout.vue?macro=true";
import { default as preview3_UUOBmExRQzegUZ_hcCVB_k8sLZX4lcPvrBv58FqXwMeta } from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-strapi/src/app/pages/preview.vue?macro=true";
import { default as searchcTCv_xHa_BLfkhs7Tm2KMorBMruuOOxxd1OybLdwasMMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/search.vue?macro=true";
import { default as successpN8QTOxslKzeGBt4eqsQlgYE2_cETxXDQgZqpnUoiAMMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/success.vue?macro=true";
import { default as wishlistmpA9fj1mHMDbbBeHg4cYLawoiaJFIFeRnIVdOG6RYzoMeta } from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-magento/src/app/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93Z0KF6LDcVS_ehOGUm2Xik1YUq4VKPdpPRjGgqNn32TYMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/[...slug].vue?macro=true";
import { default as index3NLVa_JNZmhzPP_Usi3samACZ9J1PyrnsSE1Ge4nmDgMeta } from "/builds/pro/webshop/frontend/src/img/app/pages/index.vue?macro=true";
export default [
  {
    name: "design-system-dependencies-formkit",
    path: "/design-system/dependencies/formkit",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/design-system/dependencies/formkit.vue")
  },
  {
    name: "serviceaanvraag-store",
    path: "/serviceaanvraag/:store(.*)*",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/serviceaanvraag/[...store].vue")
  },
  {
    name: "~blog-detail",
    path: "/~blog-detail",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/~blog-detail.vue")
  },
  {
    name: "~brands",
    path: "/~brands",
    component: () => import("/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/pages/~brands.vue")
  },
  {
    name: "~cms-columns",
    path: "/~cms-columns",
    component: () => import("/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-strapi/src/app/pages/~cms-columns.vue")
  },
  {
    name: "~customer-service-detail",
    path: "/~customer-service-detail",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/~customer-service-detail.vue")
  },
  {
    name: "~pdp",
    path: "/~pdp",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/~pdp.vue")
  },
  {
    name: "~store-detail",
    path: "/~store-detail",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/~store-detail.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/checkout.vue"),
    children: [
  {
    name: "checkout-payment",
    path: "payment",
    meta: paymentpstU9iFt9EG8YABmqpzqNXvRy0OECqzLi7UYofwO94QMeta || {},
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/checkout/payment.vue")
  },
  {
    name: "checkout-shipment",
    path: "shipment",
    meta: shipmentE9X1OumRFD57_S0mtR7KAQ2WYPApNatBVmMqonrIh8QMeta || {},
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/checkout/shipment.vue")
  },
  {
    name: "checkout-index",
    path: "",
    meta: indexCHnLsUDw_3Z2vvqIYgbL1JAnx_OSyLdCpoCldOH3SUwMeta || {},
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/checkout/index.vue")
  }
]
  },
  {
    name: "embed",
    path: "/embed",
    meta: embed9WtzouZDbYALE3l_kCWtyakAmZR66Nk3nYdIl2a4r5wMeta || {},
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/embed.vue")
  },
  {
    name: "empty-layout",
    path: "/empty-layout",
    meta: empty_45layout4KSMdh5RTw4o2VFP7GY1E_qv8XSPt4FagwQPgqURDeoMeta || {},
    component: () => import("/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/pages/empty-layout.vue")
  },
  {
    name: "preview",
    path: "/preview",
    component: () => import("/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-strapi/src/app/pages/preview.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/search.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/success.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-magento/src/app/pages/wishlist.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/pro/webshop/frontend/src/img/app/pages/index.vue")
  }
]